// Generated by Scripts/compile-product-event-contract.mjs from the canonical catalogue. Do not edit.

export type GeneratedProductEventRuntimePropertySchema = {
  type: "boolean" | "string" | "search_term";
  values: readonly string[];
  optional: boolean;
};

export const generatedProductEventSchemas = {
  "guest_shared_list_view": {
    "surface": {
      "type": "string",
      "values": [
        "shared_list"
      ],
      "optional": false
    },
    "access_state": {
      "type": "string",
      "values": [
        "editable",
        "read_only",
        "expired",
        "access_unavailable",
        "not_found",
        "load_error"
      ],
      "optional": false
    },
    "cta_mode": {
      "type": "string",
      "values": [
        "testflight",
        "app_store",
        "download"
      ],
      "optional": false
    }
  },
  "guest_shared_list_access_error": {
    "surface": {
      "type": "string",
      "values": [
        "shared_list"
      ],
      "optional": false
    },
    "access_state": {
      "type": "string",
      "values": [
        "editable",
        "read_only",
        "expired",
        "access_unavailable",
        "not_found",
        "load_error"
      ],
      "optional": false
    },
    "cta_mode": {
      "type": "string",
      "values": [
        "testflight",
        "app_store",
        "download"
      ],
      "optional": false
    },
    "result": {
      "type": "string",
      "values": [
        "blocked"
      ],
      "optional": false
    }
  },
  "guest_shared_list_availability": {
    "surface": {
      "type": "string",
      "values": [
        "shared_list"
      ],
      "optional": false
    },
    "phase": {
      "type": "string",
      "values": [
        "detected",
        "recovered"
      ],
      "optional": false
    },
    "mode": {
      "type": "string",
      "values": [
        "prolonged_loading",
        "saved_snapshot"
      ],
      "optional": false
    },
    "connection_state": {
      "type": "string",
      "values": [
        "online",
        "offline"
      ],
      "optional": false
    }
  },
  "guest_shared_list_action": {
    "surface": {
      "type": "string",
      "values": [
        "shared_list"
      ],
      "optional": false
    },
    "access_state": {
      "type": "string",
      "values": [
        "editable",
        "read_only",
        "expired",
        "access_unavailable",
        "not_found",
        "load_error"
      ],
      "optional": false
    },
    "action": {
      "type": "string",
      "values": [
        "add_item",
        "toggle_item",
        "rename_item",
        "delete_item"
      ],
      "optional": false
    },
    "result": {
      "type": "string",
      "values": [
        "success",
        "failure",
        "blocked"
      ],
      "optional": false
    },
    "cta_mode": {
      "type": "string",
      "values": [
        "testflight",
        "app_store",
        "download"
      ],
      "optional": false
    },
    "reason": {
      "type": "string",
      "values": [
        "editing_disabled"
      ],
      "optional": true
    }
  },
  "guest_shared_list_cta_impression": {
    "surface": {
      "type": "string",
      "values": [
        "shared_list"
      ],
      "optional": false
    },
    "access_state": {
      "type": "string",
      "values": [
        "editable",
        "read_only",
        "expired",
        "access_unavailable",
        "not_found",
        "load_error"
      ],
      "optional": false
    },
    "cta_mode": {
      "type": "string",
      "values": [
        "testflight",
        "app_store",
        "download"
      ],
      "optional": false
    }
  },
  "guest_shared_list_cta_click": {
    "surface": {
      "type": "string",
      "values": [
        "shared_list"
      ],
      "optional": false
    },
    "access_state": {
      "type": "string",
      "values": [
        "editable",
        "read_only",
        "expired",
        "access_unavailable",
        "not_found",
        "load_error"
      ],
      "optional": false
    },
    "cta_mode": {
      "type": "string",
      "values": [
        "testflight",
        "app_store",
        "download"
      ],
      "optional": false
    }
  },
  "app_session_started": {
    "entry_point": {
      "type": "string",
      "values": [
        "cold_launch",
        "warm_resume"
      ],
      "optional": false
    },
    "initial_surface": {
      "type": "string",
      "values": [
        "recipes",
        "grocery",
        "settings"
      ],
      "optional": false
    }
  },
  "authentication_method_selected": {
    "method": {
      "type": "string",
      "values": [
        "email_link",
        "apple",
        "google"
      ],
      "optional": false
    },
    "surface": {
      "type": "string",
      "values": [
        "auth_landing"
      ],
      "optional": false
    }
  },
  "authentication_started": {
    "method": {
      "type": "string",
      "values": [
        "email_link",
        "apple",
        "google"
      ],
      "optional": false
    }
  },
  "authentication_completed": {
    "method": {
      "type": "string",
      "values": [
        "email_link",
        "apple",
        "google"
      ],
      "optional": false
    },
    "account_state": {
      "type": "string",
      "values": [
        "new_account",
        "returning_account",
        "unknown"
      ],
      "optional": false
    }
  },
  "authentication_failed": {
    "method": {
      "type": "string",
      "values": [
        "email_link",
        "apple",
        "google"
      ],
      "optional": false
    },
    "reason": {
      "type": "string",
      "values": [
        "cancelled",
        "configuration",
        "provider",
        "firebase"
      ],
      "optional": false
    }
  },
  "user_activated": {
    "activation_path": {
      "type": "string",
      "values": [
        "grocery_add",
        "grocery_check",
        "recipe_to_list",
        "confirmed_cook",
        "recipe_import"
      ],
      "optional": false
    }
  },
  "grocery_list_activated": {
    "first_item_source": {
      "type": "string",
      "values": [
        "manual",
        "quick_add",
        "recipe",
        "shared_list"
      ],
      "optional": false
    }
  },
  "grocery_item_added": {
    "source": {
      "type": "string",
      "values": [
        "manual",
        "quick_add",
        "recipe",
        "shared_list"
      ],
      "optional": false
    }
  },
  "grocery_item_checked": {
    "checked": {
      "type": "boolean",
      "values": [],
      "optional": false
    },
    "surface": {
      "type": "string",
      "values": [
        "grocery_list",
        "shared_list",
        "recipe"
      ],
      "optional": false
    }
  },
  "quick_add_suggestion_selected": {
    "source": {
      "type": "string",
      "values": [
        "buy_again",
        "grocery_catalogue",
        "starter_suggestion"
      ],
      "optional": false
    }
  },
  "shared_list_created": {
    "access_setting": {
      "type": "string",
      "values": [
        "editable",
        "read_only"
      ],
      "optional": false
    },
    "expiry_bucket": {
      "type": "string",
      "values": [
        "under_1_day",
        "1_to_7_days",
        "over_7_days",
        "permanent"
      ],
      "optional": false
    }
  },
  "recipe_add_entry_viewed": {
    "surface": {
      "type": "string",
      "values": [
        "empty_library"
      ],
      "optional": false
    }
  },
  "recipe_add_source_selected": {
    "surface": {
      "type": "string",
      "values": [
        "empty_library"
      ],
      "optional": false
    },
    "source": {
      "type": "string",
      "values": [
        "camera",
        "photos"
      ],
      "optional": false
    }
  },
  "recipe_camera_viewed": {
    "mode": {
      "type": "string",
      "values": [
        "single_photo",
        "recipe_import"
      ],
      "optional": false
    }
  },
  "recipe_camera_action": {
    "mode": {
      "type": "string",
      "values": [
        "single_photo",
        "recipe_import"
      ],
      "optional": false
    },
    "action": {
      "type": "string",
      "values": [
        "photo_captured",
        "capture_failed",
        "camera_photo_used",
        "photos_opened",
        "photos_selected",
        "photos_cancelled",
        "photos_failed",
        "camera_cancelled",
        "camera_permission_denied",
        "camera_permission_photos_opened",
        "camera_permission_settings_opened",
        "camera_permission_recovery_cancelled"
      ],
      "optional": false
    }
  },
  "recipe_import_started": {
    "source": {
      "type": "string",
      "values": [
        "camera",
        "photos",
        "url",
        "share_extension"
      ],
      "optional": false
    }
  },
  "recipe_import_completed": {
    "source": {
      "type": "string",
      "values": [
        "camera",
        "photos",
        "url",
        "share_extension"
      ],
      "optional": false
    },
    "duration_bucket": {
      "type": "string",
      "values": [
        "under_1_minute",
        "1_to_5_minutes",
        "over_5_minutes"
      ],
      "optional": false
    }
  },
  "recipe_import_failed": {
    "source": {
      "type": "string",
      "values": [
        "camera",
        "photos",
        "url",
        "share_extension"
      ],
      "optional": false
    },
    "error_category": {
      "type": "string",
      "values": [
        "invalid_input",
        "network",
        "extraction",
        "storage",
        "unknown"
      ],
      "optional": false
    },
    "retryable": {
      "type": "boolean",
      "values": [],
      "optional": false
    }
  },
  "recipe_opened": {
    "source": {
      "type": "string",
      "values": [
        "recipe_list",
        "search",
        "favorites",
        "cooking_history",
        "deep_link"
      ],
      "optional": false
    }
  },
  "recipe_translation_started": {
    "source": {
      "type": "string",
      "values": [
        "menu",
        "contextual"
      ],
      "optional": false
    }
  },
  "recipe_translation_completed": {},
  "recipe_translation_failed": {
    "reason": {
      "type": "string",
      "values": [
        "cancelled",
        "unsupported",
        "failed",
        "invalidated"
      ],
      "optional": false
    }
  },
  "recipe_translation_original_shown": {},
  "recipe_translation_eligibility": {
    "outcome": {
      "type": "string",
      "values": [
        "eligible",
        "matching",
        "uncertain",
        "unsupported"
      ],
      "optional": false
    }
  },
  "recipe_translation_prompt_shown": {},
  "recipe_translation_prompt_selected": {},
  "recipe_translation_grocery_added": {
    "ingredient_count_bucket": {
      "type": "string",
      "values": [
        "1_to_5",
        "6_to_10",
        "11_to_20",
        "over_20"
      ],
      "optional": false
    }
  },
  "recipe_search_results": {
    "algorithm": {
      "type": "string",
      "values": [
        "keyword_metadata_v2"
      ],
      "optional": false
    },
    "result_count_bucket": {
      "type": "string",
      "values": [
        "zero",
        "one",
        "2_to_5",
        "6_to_20",
        "over_20"
      ],
      "optional": false
    },
    "term_count_bucket": {
      "type": "string",
      "values": [
        "zero",
        "one",
        "2_to_3",
        "4_to_8",
        "over_8"
      ],
      "optional": false
    },
    "filter_count_bucket": {
      "type": "string",
      "values": [
        "zero",
        "one",
        "2_to_3",
        "over_3"
      ],
      "optional": false
    },
    "library_size_bucket": {
      "type": "string",
      "values": [
        "zero",
        "1_to_20",
        "21_to_100",
        "101_to_1000",
        "over_1000"
      ],
      "optional": false
    },
    "metadata_coverage": {
      "type": "string",
      "values": [
        "none",
        "some",
        "all"
      ],
      "optional": false
    },
    "status": {
      "type": "string",
      "values": [
        "matches",
        "no_matches",
        "conflict",
        "unresolved"
      ],
      "optional": false
    },
    "latency_bucket": {
      "type": "string",
      "values": [
        "under_100_ms",
        "100_to_300_ms",
        "301_to_1000_ms",
        "over_1000_ms"
      ],
      "optional": false
    },
    "trigger": {
      "type": "string",
      "values": [
        "pause",
        "submit",
        "open",
        "exit"
      ],
      "optional": false
    },
    "search_term": {
      "type": "search_term",
      "values": [],
      "optional": true
    }
  },
  "recipe_search_action": {
    "action": {
      "type": "string",
      "values": [
        "suggestion_submit",
        "suggestion_fill",
        "filter_suggestion",
        "correction",
        "sort",
        "filters_changed",
        "clear_recents",
        "remove_recent"
      ],
      "optional": false
    },
    "suggestion_kind": {
      "type": "string",
      "values": [
        "none",
        "recent",
        "completion",
        "filter"
      ],
      "optional": false
    }
  },
  "recipe_search_result_opened": {
    "rank_bucket": {
      "type": "string",
      "values": [
        "first",
        "2_to_3",
        "4_to_10",
        "11_to_24",
        "over_24"
      ],
      "optional": false
    },
    "result_count_bucket": {
      "type": "string",
      "values": [
        "zero",
        "one",
        "2_to_5",
        "6_to_20",
        "over_20"
      ],
      "optional": false
    },
    "refined": {
      "type": "boolean",
      "values": [],
      "optional": false
    },
    "search_term": {
      "type": "search_term",
      "values": [],
      "optional": true
    }
  },
  "recipe_search_ended": {
    "outcome": {
      "type": "string",
      "values": [
        "opened",
        "cleared",
        "left",
        "background"
      ],
      "optional": false
    },
    "attempt_count_bucket": {
      "type": "string",
      "values": [
        "zero",
        "one",
        "2_to_5",
        "6_to_20",
        "over_20"
      ],
      "optional": false
    },
    "had_zero_results": {
      "type": "boolean",
      "values": [],
      "optional": false
    },
    "recovered_from_zero": {
      "type": "boolean",
      "values": [],
      "optional": false
    },
    "used_suggestion": {
      "type": "boolean",
      "values": [],
      "optional": false
    },
    "duration_bucket": {
      "type": "string",
      "values": [
        "under_10_seconds",
        "10_to_60_seconds",
        "over_60_seconds"
      ],
      "optional": false
    }
  },
  "recipe_notes_opened": {
    "note_count_bucket": {
      "type": "string",
      "values": [
        "unknown",
        "zero",
        "one",
        "2_to_5",
        "6_to_20",
        "over_20"
      ],
      "optional": false
    }
  },
  "recipe_note_action": {
    "action": {
      "type": "string",
      "values": [
        "add",
        "delete",
        "undo"
      ],
      "optional": false
    },
    "result": {
      "type": "string",
      "values": [
        "queued",
        "local_failure",
        "synchronized",
        "sync_failure"
      ],
      "optional": false
    },
    "note_length_bucket": {
      "type": "string",
      "values": [
        "under_80",
        "80_to_280",
        "281_to_1000",
        "over_1000"
      ],
      "optional": false
    },
    "failure_reason": {
      "type": "string",
      "values": [
        "none",
        "local_storage",
        "access_or_server",
        "conflict"
      ],
      "optional": false
    }
  },
  "recipe_notes_closed": {
    "outcome": {
      "type": "string",
      "values": [
        "viewed",
        "added",
        "draft_discarded"
      ],
      "optional": false
    },
    "duration_bucket": {
      "type": "string",
      "values": [
        "under_10_seconds",
        "10_to_60_seconds",
        "over_60_seconds"
      ],
      "optional": false
    }
  },
  "recipe_added_to_grocery_list": {
    "ingredient_count_bucket": {
      "type": "string",
      "values": [
        "1_to_5",
        "6_to_10",
        "11_to_20",
        "over_20"
      ],
      "optional": false
    }
  },
  "cooking_session_started": {
    "trigger": {
      "type": "string",
      "values": [
        "instruction_focus",
        "timer_start"
      ],
      "optional": false
    }
  },
  "confirmed_cook_recorded": {
    "entry_point": {
      "type": "string",
      "values": [
        "recipe_detail",
        "cooking_session",
        "cooking_history"
      ],
      "optional": false
    }
  },
  "cooking_timer_started": {
    "duration_bucket": {
      "type": "string",
      "values": [
        "under_5_minutes",
        "5_to_15_minutes",
        "16_to_30_minutes",
        "over_30_minutes"
      ],
      "optional": false
    }
  },
  "cooking_timer_expiry_presented": {
    "surface": {
      "type": "string",
      "values": [
        "compact",
        "inline",
        "fallback"
      ],
      "optional": false
    },
    "delivery": {
      "type": "string",
      "values": [
        "foreground",
        "notification"
      ],
      "optional": false
    }
  },
  "cooking_timer_alert_silenced": {
    "elapsed_bucket": {
      "type": "string",
      "values": [
        "under_30_seconds",
        "30_seconds_to_5_minutes",
        "5_to_15_minutes",
        "over_15_minutes"
      ],
      "optional": false
    }
  },
  "cooking_timer_acknowledged": {
    "action": {
      "type": "string",
      "values": [
        "stop",
        "add_time"
      ],
      "optional": false
    },
    "extension_kind": {
      "type": "string",
      "values": [
        "preset",
        "custom"
      ],
      "optional": true
    },
    "elapsed_bucket": {
      "type": "string",
      "values": [
        "under_30_seconds",
        "30_seconds_to_5_minutes",
        "5_to_15_minutes",
        "over_15_minutes"
      ],
      "optional": false
    }
  },
  "notification_primer_presented": {
    "context": {
      "type": "string",
      "values": [
        "timer",
        "recipe_import"
      ],
      "optional": false
    }
  },
  "notification_permission_requested": {
    "context": {
      "type": "string",
      "values": [
        "timer",
        "recipe_import"
      ],
      "optional": false
    }
  },
  "notification_permission_result": {
    "context": {
      "type": "string",
      "values": [
        "timer",
        "recipe_import"
      ],
      "optional": false
    },
    "result": {
      "type": "string",
      "values": [
        "authorized",
        "denied",
        "provisional",
        "ephemeral",
        "not_determined"
      ],
      "optional": false
    }
  },
  "notification_opened": {
    "destination": {
      "type": "string",
      "values": [
        "recipe",
        "cooking_timer"
      ],
      "optional": false
    }
  },
  "share_sheet_opened": {
    "surface": {
      "type": "string",
      "values": [
        "household_invitation",
        "shared_grocery_list"
      ],
      "optional": false
    }
  },
  "share_completed": {
    "surface": {
      "type": "string",
      "values": [
        "household_invitation",
        "shared_grocery_list"
      ],
      "optional": false
    },
    "channel": {
      "type": "string",
      "values": [
        "messages",
        "mail",
        "airdrop",
        "copy",
        "other"
      ],
      "optional": false
    }
  },
  "commerce_offer_viewed": {
    "surface": {
      "type": "string",
      "values": [
        "profile",
        "recipe_import"
      ],
      "optional": false
    },
    "result": {
      "type": "string",
      "values": [
        "available",
        "unavailable"
      ],
      "optional": false
    }
  },
  "commerce_purchase_started": {
    "surface": {
      "type": "string",
      "values": [
        "profile",
        "recipe_import"
      ],
      "optional": false
    }
  },
  "commerce_purchase_result": {
    "surface": {
      "type": "string",
      "values": [
        "profile",
        "recipe_import"
      ],
      "optional": false
    },
    "result": {
      "type": "string",
      "values": [
        "completed",
        "pending",
        "cancelled",
        "failure"
      ],
      "optional": false
    }
  },
  "commerce_allowance_exhausted": {
    "cost_driver": {
      "type": "string",
      "values": [
        "recipe_import"
      ],
      "optional": false
    }
  },
  "commerce_grant_completed": {
    "environment": {
      "type": "string",
      "values": [
        "sandbox",
        "production"
      ],
      "optional": false
    }
  },
  "commerce_billable_action_committed": {
    "cost_driver": {
      "type": "string",
      "values": [
        "recipe_import"
      ],
      "optional": false
    },
    "funding": {
      "type": "string",
      "values": [
        "free",
        "purchased",
        "mixed"
      ],
      "optional": false
    }
  },
  "prominent_cooking_alarm_preference_changed": {
    "enabled": {
      "type": "boolean",
      "values": [],
      "optional": false
    },
    "authorization": {
      "type": "string",
      "values": [
        "not_determined",
        "denied",
        "authorized",
        "unsupported"
      ],
      "optional": false
    }
  },
  "app_review_experiment_event": {
    "experiment": {
      "type": "string",
      "values": [
        "second_import_v1"
      ],
      "optional": false
    },
    "variant": {
      "type": "string",
      "values": [
        "prompt",
        "holdout"
      ],
      "optional": false
    },
    "phase": {
      "type": "string",
      "values": [
        "enrolled",
        "eligible",
        "opportunity",
        "request_attempted"
      ],
      "optional": false
    }
  }
} as const satisfies Record<string, Record<string, GeneratedProductEventRuntimePropertySchema>>;

export const generatedProductEventSchemaVersions = {
  "guest_shared_list_view": 1,
  "guest_shared_list_access_error": 1,
  "guest_shared_list_availability": 1,
  "guest_shared_list_action": 1,
  "guest_shared_list_cta_impression": 2,
  "guest_shared_list_cta_click": 1,
  "app_session_started": 1,
  "authentication_method_selected": 1,
  "authentication_started": 1,
  "authentication_completed": 2,
  "authentication_failed": 1,
  "user_activated": 1,
  "grocery_list_activated": 1,
  "grocery_item_added": 1,
  "grocery_item_checked": 1,
  "quick_add_suggestion_selected": 1,
  "shared_list_created": 1,
  "recipe_add_entry_viewed": 1,
  "recipe_add_source_selected": 1,
  "recipe_camera_viewed": 1,
  "recipe_camera_action": 1,
  "recipe_import_started": 1,
  "recipe_import_completed": 1,
  "recipe_import_failed": 1,
  "recipe_opened": 1,
  "recipe_translation_started": 1,
  "recipe_translation_completed": 1,
  "recipe_translation_failed": 1,
  "recipe_translation_original_shown": 1,
  "recipe_translation_eligibility": 1,
  "recipe_translation_prompt_shown": 1,
  "recipe_translation_prompt_selected": 1,
  "recipe_translation_grocery_added": 1,
  "recipe_search_results": 1,
  "recipe_search_action": 1,
  "recipe_search_result_opened": 1,
  "recipe_search_ended": 1,
  "recipe_notes_opened": 1,
  "recipe_note_action": 1,
  "recipe_notes_closed": 1,
  "recipe_added_to_grocery_list": 1,
  "cooking_session_started": 1,
  "confirmed_cook_recorded": 1,
  "cooking_timer_started": 1,
  "cooking_timer_expiry_presented": 1,
  "cooking_timer_alert_silenced": 1,
  "cooking_timer_acknowledged": 1,
  "notification_primer_presented": 1,
  "notification_permission_requested": 1,
  "notification_permission_result": 1,
  "notification_opened": 1,
  "share_sheet_opened": 1,
  "share_completed": 1,
  "commerce_offer_viewed": 1,
  "commerce_purchase_started": 1,
  "commerce_purchase_result": 1,
  "commerce_allowance_exhausted": 1,
  "commerce_grant_completed": 1,
  "commerce_billable_action_committed": 1,
  "prominent_cooking_alarm_preference_changed": 1,
  "app_review_experiment_event": 1
} as const;

export const generatedProductEventSamplingPolicies = {
  "guest_shared_list_view": {
    "mode": "full",
    "rate": 1
  },
  "guest_shared_list_access_error": {
    "mode": "full",
    "rate": 1
  },
  "guest_shared_list_availability": {
    "mode": "full",
    "rate": 1
  },
  "guest_shared_list_action": {
    "mode": "full",
    "rate": 1
  },
  "guest_shared_list_cta_impression": {
    "mode": "full",
    "rate": 1
  },
  "guest_shared_list_cta_click": {
    "mode": "full",
    "rate": 1
  },
  "app_session_started": {
    "mode": "full",
    "rate": 1
  },
  "authentication_method_selected": {
    "mode": "full",
    "rate": 1
  },
  "authentication_started": {
    "mode": "full",
    "rate": 1
  },
  "authentication_completed": {
    "mode": "full",
    "rate": 1
  },
  "authentication_failed": {
    "mode": "full",
    "rate": 1
  },
  "user_activated": {
    "mode": "full",
    "rate": 1
  },
  "grocery_list_activated": {
    "mode": "full",
    "rate": 1
  },
  "grocery_item_added": {
    "mode": "full",
    "rate": 1
  },
  "grocery_item_checked": {
    "mode": "full",
    "rate": 1
  },
  "quick_add_suggestion_selected": {
    "mode": "full",
    "rate": 1
  },
  "shared_list_created": {
    "mode": "full",
    "rate": 1
  },
  "recipe_add_entry_viewed": {
    "mode": "full",
    "rate": 1
  },
  "recipe_add_source_selected": {
    "mode": "full",
    "rate": 1
  },
  "recipe_camera_viewed": {
    "mode": "full",
    "rate": 1
  },
  "recipe_camera_action": {
    "mode": "full",
    "rate": 1
  },
  "recipe_import_started": {
    "mode": "full",
    "rate": 1
  },
  "recipe_import_completed": {
    "mode": "full",
    "rate": 1
  },
  "recipe_import_failed": {
    "mode": "full",
    "rate": 1
  },
  "recipe_opened": {
    "mode": "full",
    "rate": 1
  },
  "recipe_translation_started": {
    "mode": "full",
    "rate": 1
  },
  "recipe_translation_completed": {
    "mode": "full",
    "rate": 1
  },
  "recipe_translation_failed": {
    "mode": "full",
    "rate": 1
  },
  "recipe_translation_original_shown": {
    "mode": "full",
    "rate": 1
  },
  "recipe_translation_eligibility": {
    "mode": "full",
    "rate": 1
  },
  "recipe_translation_prompt_shown": {
    "mode": "full",
    "rate": 1
  },
  "recipe_translation_prompt_selected": {
    "mode": "full",
    "rate": 1
  },
  "recipe_translation_grocery_added": {
    "mode": "full",
    "rate": 1
  },
  "recipe_search_results": {
    "mode": "full",
    "rate": 1
  },
  "recipe_search_action": {
    "mode": "full",
    "rate": 1
  },
  "recipe_search_result_opened": {
    "mode": "full",
    "rate": 1
  },
  "recipe_search_ended": {
    "mode": "full",
    "rate": 1
  },
  "recipe_notes_opened": {
    "mode": "full",
    "rate": 1
  },
  "recipe_note_action": {
    "mode": "full",
    "rate": 1
  },
  "recipe_notes_closed": {
    "mode": "full",
    "rate": 1
  },
  "recipe_added_to_grocery_list": {
    "mode": "full",
    "rate": 1
  },
  "cooking_session_started": {
    "mode": "full",
    "rate": 1
  },
  "confirmed_cook_recorded": {
    "mode": "full",
    "rate": 1
  },
  "cooking_timer_started": {
    "mode": "full",
    "rate": 1
  },
  "cooking_timer_expiry_presented": {
    "mode": "full",
    "rate": 1
  },
  "cooking_timer_alert_silenced": {
    "mode": "full",
    "rate": 1
  },
  "cooking_timer_acknowledged": {
    "mode": "full",
    "rate": 1
  },
  "notification_primer_presented": {
    "mode": "full",
    "rate": 1
  },
  "notification_permission_requested": {
    "mode": "full",
    "rate": 1
  },
  "notification_permission_result": {
    "mode": "full",
    "rate": 1
  },
  "notification_opened": {
    "mode": "full",
    "rate": 1
  },
  "share_sheet_opened": {
    "mode": "full",
    "rate": 1
  },
  "share_completed": {
    "mode": "full",
    "rate": 1
  },
  "commerce_offer_viewed": {
    "mode": "full",
    "rate": 1
  },
  "commerce_purchase_started": {
    "mode": "full",
    "rate": 1
  },
  "commerce_purchase_result": {
    "mode": "full",
    "rate": 1
  },
  "commerce_allowance_exhausted": {
    "mode": "full",
    "rate": 1
  },
  "commerce_grant_completed": {
    "mode": "full",
    "rate": 1
  },
  "commerce_billable_action_committed": {
    "mode": "full",
    "rate": 1
  },
  "prominent_cooking_alarm_preference_changed": {
    "mode": "full",
    "rate": 1
  },
  "app_review_experiment_event": {
    "mode": "full",
    "rate": 1
  }
} as const;

export const generatedProductEventNames = Object.freeze(Object.keys(generatedProductEventSchemas));

export type GeneratedProductEventContract =
  | {
      readonly name: "guest_shared_list_view";
      readonly schemaVersion: 1;
      readonly properties: {
      readonly "surface": "shared_list";
      readonly "access_state": "editable" | "read_only" | "expired" | "access_unavailable" | "not_found" | "load_error";
      readonly "cta_mode": "testflight" | "app_store" | "download";
      };
    }
  | {
      readonly name: "guest_shared_list_access_error";
      readonly schemaVersion: 1;
      readonly properties: {
      readonly "surface": "shared_list";
      readonly "access_state": "editable" | "read_only" | "expired" | "access_unavailable" | "not_found" | "load_error";
      readonly "cta_mode": "testflight" | "app_store" | "download";
      readonly "result": "blocked";
      };
    }
  | {
      readonly name: "guest_shared_list_availability";
      readonly schemaVersion: 1;
      readonly properties: {
      readonly "surface": "shared_list";
      readonly "phase": "detected" | "recovered";
      readonly "mode": "prolonged_loading" | "saved_snapshot";
      readonly "connection_state": "online" | "offline";
      };
    }
  | {
      readonly name: "guest_shared_list_action";
      readonly schemaVersion: 1;
      readonly properties: {
      readonly "surface": "shared_list";
      readonly "access_state": "editable" | "read_only" | "expired" | "access_unavailable" | "not_found" | "load_error";
      readonly "action": "add_item" | "toggle_item" | "rename_item" | "delete_item";
      readonly "result": "success" | "failure" | "blocked";
      readonly "cta_mode": "testflight" | "app_store" | "download";
      readonly "reason"?: "editing_disabled";
      };
    }
  | {
      readonly name: "guest_shared_list_cta_impression";
      readonly schemaVersion: 2;
      readonly properties: {
      readonly "surface": "shared_list";
      readonly "access_state": "editable" | "read_only" | "expired" | "access_unavailable" | "not_found" | "load_error";
      readonly "cta_mode": "testflight" | "app_store" | "download";
      };
    }
  | {
      readonly name: "guest_shared_list_cta_click";
      readonly schemaVersion: 1;
      readonly properties: {
      readonly "surface": "shared_list";
      readonly "access_state": "editable" | "read_only" | "expired" | "access_unavailable" | "not_found" | "load_error";
      readonly "cta_mode": "testflight" | "app_store" | "download";
      };
    }
  | {
      readonly name: "app_session_started";
      readonly schemaVersion: 1;
      readonly properties: {
      readonly "entry_point": "cold_launch" | "warm_resume";
      readonly "initial_surface": "recipes" | "grocery" | "settings";
      };
    }
  | {
      readonly name: "authentication_method_selected";
      readonly schemaVersion: 1;
      readonly properties: {
      readonly "method": "email_link" | "apple" | "google";
      readonly "surface": "auth_landing";
      };
    }
  | {
      readonly name: "authentication_started";
      readonly schemaVersion: 1;
      readonly properties: {
      readonly "method": "email_link" | "apple" | "google";
      };
    }
  | {
      readonly name: "authentication_completed";
      readonly schemaVersion: 2;
      readonly properties: {
      readonly "method": "email_link" | "apple" | "google";
      readonly "account_state": "new_account" | "returning_account" | "unknown";
      };
    }
  | {
      readonly name: "authentication_failed";
      readonly schemaVersion: 1;
      readonly properties: {
      readonly "method": "email_link" | "apple" | "google";
      readonly "reason": "cancelled" | "configuration" | "provider" | "firebase";
      };
    }
  | {
      readonly name: "user_activated";
      readonly schemaVersion: 1;
      readonly properties: {
      readonly "activation_path": "grocery_add" | "grocery_check" | "recipe_to_list" | "confirmed_cook" | "recipe_import";
      };
    }
  | {
      readonly name: "grocery_list_activated";
      readonly schemaVersion: 1;
      readonly properties: {
      readonly "first_item_source": "manual" | "quick_add" | "recipe" | "shared_list";
      };
    }
  | {
      readonly name: "grocery_item_added";
      readonly schemaVersion: 1;
      readonly properties: {
      readonly "source": "manual" | "quick_add" | "recipe" | "shared_list";
      };
    }
  | {
      readonly name: "grocery_item_checked";
      readonly schemaVersion: 1;
      readonly properties: {
      readonly "checked": boolean;
      readonly "surface": "grocery_list" | "shared_list" | "recipe";
      };
    }
  | {
      readonly name: "quick_add_suggestion_selected";
      readonly schemaVersion: 1;
      readonly properties: {
      readonly "source": "buy_again" | "grocery_catalogue" | "starter_suggestion";
      };
    }
  | {
      readonly name: "shared_list_created";
      readonly schemaVersion: 1;
      readonly properties: {
      readonly "access_setting": "editable" | "read_only";
      readonly "expiry_bucket": "under_1_day" | "1_to_7_days" | "over_7_days" | "permanent";
      };
    }
  | {
      readonly name: "recipe_add_entry_viewed";
      readonly schemaVersion: 1;
      readonly properties: {
      readonly "surface": "empty_library";
      };
    }
  | {
      readonly name: "recipe_add_source_selected";
      readonly schemaVersion: 1;
      readonly properties: {
      readonly "surface": "empty_library";
      readonly "source": "camera" | "photos";
      };
    }
  | {
      readonly name: "recipe_camera_viewed";
      readonly schemaVersion: 1;
      readonly properties: {
      readonly "mode": "single_photo" | "recipe_import";
      };
    }
  | {
      readonly name: "recipe_camera_action";
      readonly schemaVersion: 1;
      readonly properties: {
      readonly "mode": "single_photo" | "recipe_import";
      readonly "action": "photo_captured" | "capture_failed" | "camera_photo_used" | "photos_opened" | "photos_selected" | "photos_cancelled" | "photos_failed" | "camera_cancelled" | "camera_permission_denied" | "camera_permission_photos_opened" | "camera_permission_settings_opened" | "camera_permission_recovery_cancelled";
      };
    }
  | {
      readonly name: "recipe_import_started";
      readonly schemaVersion: 1;
      readonly properties: {
      readonly "source": "camera" | "photos" | "url" | "share_extension";
      };
    }
  | {
      readonly name: "recipe_import_completed";
      readonly schemaVersion: 1;
      readonly properties: {
      readonly "source": "camera" | "photos" | "url" | "share_extension";
      readonly "duration_bucket": "under_1_minute" | "1_to_5_minutes" | "over_5_minutes";
      };
    }
  | {
      readonly name: "recipe_import_failed";
      readonly schemaVersion: 1;
      readonly properties: {
      readonly "source": "camera" | "photos" | "url" | "share_extension";
      readonly "error_category": "invalid_input" | "network" | "extraction" | "storage" | "unknown";
      readonly "retryable": boolean;
      };
    }
  | {
      readonly name: "recipe_opened";
      readonly schemaVersion: 1;
      readonly properties: {
      readonly "source": "recipe_list" | "search" | "favorites" | "cooking_history" | "deep_link";
      };
    }
  | {
      readonly name: "recipe_translation_started";
      readonly schemaVersion: 1;
      readonly properties: {
      readonly "source": "menu" | "contextual";
      };
    }
  | {
      readonly name: "recipe_translation_completed";
      readonly schemaVersion: 1;
      readonly properties: Record<string, never>;
    }
  | {
      readonly name: "recipe_translation_failed";
      readonly schemaVersion: 1;
      readonly properties: {
      readonly "reason": "cancelled" | "unsupported" | "failed" | "invalidated";
      };
    }
  | {
      readonly name: "recipe_translation_original_shown";
      readonly schemaVersion: 1;
      readonly properties: Record<string, never>;
    }
  | {
      readonly name: "recipe_translation_eligibility";
      readonly schemaVersion: 1;
      readonly properties: {
      readonly "outcome": "eligible" | "matching" | "uncertain" | "unsupported";
      };
    }
  | {
      readonly name: "recipe_translation_prompt_shown";
      readonly schemaVersion: 1;
      readonly properties: Record<string, never>;
    }
  | {
      readonly name: "recipe_translation_prompt_selected";
      readonly schemaVersion: 1;
      readonly properties: Record<string, never>;
    }
  | {
      readonly name: "recipe_translation_grocery_added";
      readonly schemaVersion: 1;
      readonly properties: {
      readonly "ingredient_count_bucket": "1_to_5" | "6_to_10" | "11_to_20" | "over_20";
      };
    }
  | {
      readonly name: "recipe_search_results";
      readonly schemaVersion: 1;
      readonly properties: {
      readonly "algorithm": "keyword_metadata_v2";
      readonly "result_count_bucket": "zero" | "one" | "2_to_5" | "6_to_20" | "over_20";
      readonly "term_count_bucket": "zero" | "one" | "2_to_3" | "4_to_8" | "over_8";
      readonly "filter_count_bucket": "zero" | "one" | "2_to_3" | "over_3";
      readonly "library_size_bucket": "zero" | "1_to_20" | "21_to_100" | "101_to_1000" | "over_1000";
      readonly "metadata_coverage": "none" | "some" | "all";
      readonly "status": "matches" | "no_matches" | "conflict" | "unresolved";
      readonly "latency_bucket": "under_100_ms" | "100_to_300_ms" | "301_to_1000_ms" | "over_1000_ms";
      readonly "trigger": "pause" | "submit" | "open" | "exit";
      readonly "search_term"?: string;
      };
    }
  | {
      readonly name: "recipe_search_action";
      readonly schemaVersion: 1;
      readonly properties: {
      readonly "action": "suggestion_submit" | "suggestion_fill" | "filter_suggestion" | "correction" | "sort" | "filters_changed" | "clear_recents" | "remove_recent";
      readonly "suggestion_kind": "none" | "recent" | "completion" | "filter";
      };
    }
  | {
      readonly name: "recipe_search_result_opened";
      readonly schemaVersion: 1;
      readonly properties: {
      readonly "rank_bucket": "first" | "2_to_3" | "4_to_10" | "11_to_24" | "over_24";
      readonly "result_count_bucket": "zero" | "one" | "2_to_5" | "6_to_20" | "over_20";
      readonly "refined": boolean;
      readonly "search_term"?: string;
      };
    }
  | {
      readonly name: "recipe_search_ended";
      readonly schemaVersion: 1;
      readonly properties: {
      readonly "outcome": "opened" | "cleared" | "left" | "background";
      readonly "attempt_count_bucket": "zero" | "one" | "2_to_5" | "6_to_20" | "over_20";
      readonly "had_zero_results": boolean;
      readonly "recovered_from_zero": boolean;
      readonly "used_suggestion": boolean;
      readonly "duration_bucket": "under_10_seconds" | "10_to_60_seconds" | "over_60_seconds";
      };
    }
  | {
      readonly name: "recipe_notes_opened";
      readonly schemaVersion: 1;
      readonly properties: {
      readonly "note_count_bucket": "unknown" | "zero" | "one" | "2_to_5" | "6_to_20" | "over_20";
      };
    }
  | {
      readonly name: "recipe_note_action";
      readonly schemaVersion: 1;
      readonly properties: {
      readonly "action": "add" | "delete" | "undo";
      readonly "result": "queued" | "local_failure" | "synchronized" | "sync_failure";
      readonly "note_length_bucket": "under_80" | "80_to_280" | "281_to_1000" | "over_1000";
      readonly "failure_reason": "none" | "local_storage" | "access_or_server" | "conflict";
      };
    }
  | {
      readonly name: "recipe_notes_closed";
      readonly schemaVersion: 1;
      readonly properties: {
      readonly "outcome": "viewed" | "added" | "draft_discarded";
      readonly "duration_bucket": "under_10_seconds" | "10_to_60_seconds" | "over_60_seconds";
      };
    }
  | {
      readonly name: "recipe_added_to_grocery_list";
      readonly schemaVersion: 1;
      readonly properties: {
      readonly "ingredient_count_bucket": "1_to_5" | "6_to_10" | "11_to_20" | "over_20";
      };
    }
  | {
      readonly name: "cooking_session_started";
      readonly schemaVersion: 1;
      readonly properties: {
      readonly "trigger": "instruction_focus" | "timer_start";
      };
    }
  | {
      readonly name: "confirmed_cook_recorded";
      readonly schemaVersion: 1;
      readonly properties: {
      readonly "entry_point": "recipe_detail" | "cooking_session" | "cooking_history";
      };
    }
  | {
      readonly name: "cooking_timer_started";
      readonly schemaVersion: 1;
      readonly properties: {
      readonly "duration_bucket": "under_5_minutes" | "5_to_15_minutes" | "16_to_30_minutes" | "over_30_minutes";
      };
    }
  | {
      readonly name: "cooking_timer_expiry_presented";
      readonly schemaVersion: 1;
      readonly properties: {
      readonly "surface": "compact" | "inline" | "fallback";
      readonly "delivery": "foreground" | "notification";
      };
    }
  | {
      readonly name: "cooking_timer_alert_silenced";
      readonly schemaVersion: 1;
      readonly properties: {
      readonly "elapsed_bucket": "under_30_seconds" | "30_seconds_to_5_minutes" | "5_to_15_minutes" | "over_15_minutes";
      };
    }
  | {
      readonly name: "cooking_timer_acknowledged";
      readonly schemaVersion: 1;
      readonly properties: {
      readonly "action": "stop" | "add_time";
      readonly "extension_kind"?: "preset" | "custom";
      readonly "elapsed_bucket": "under_30_seconds" | "30_seconds_to_5_minutes" | "5_to_15_minutes" | "over_15_minutes";
      };
    }
  | {
      readonly name: "notification_primer_presented";
      readonly schemaVersion: 1;
      readonly properties: {
      readonly "context": "timer" | "recipe_import";
      };
    }
  | {
      readonly name: "notification_permission_requested";
      readonly schemaVersion: 1;
      readonly properties: {
      readonly "context": "timer" | "recipe_import";
      };
    }
  | {
      readonly name: "notification_permission_result";
      readonly schemaVersion: 1;
      readonly properties: {
      readonly "context": "timer" | "recipe_import";
      readonly "result": "authorized" | "denied" | "provisional" | "ephemeral" | "not_determined";
      };
    }
  | {
      readonly name: "notification_opened";
      readonly schemaVersion: 1;
      readonly properties: {
      readonly "destination": "recipe" | "cooking_timer";
      };
    }
  | {
      readonly name: "share_sheet_opened";
      readonly schemaVersion: 1;
      readonly properties: {
      readonly "surface": "household_invitation" | "shared_grocery_list";
      };
    }
  | {
      readonly name: "share_completed";
      readonly schemaVersion: 1;
      readonly properties: {
      readonly "surface": "household_invitation" | "shared_grocery_list";
      readonly "channel": "messages" | "mail" | "airdrop" | "copy" | "other";
      };
    }
  | {
      readonly name: "commerce_offer_viewed";
      readonly schemaVersion: 1;
      readonly properties: {
      readonly "surface": "profile" | "recipe_import";
      readonly "result": "available" | "unavailable";
      };
    }
  | {
      readonly name: "commerce_purchase_started";
      readonly schemaVersion: 1;
      readonly properties: {
      readonly "surface": "profile" | "recipe_import";
      };
    }
  | {
      readonly name: "commerce_purchase_result";
      readonly schemaVersion: 1;
      readonly properties: {
      readonly "surface": "profile" | "recipe_import";
      readonly "result": "completed" | "pending" | "cancelled" | "failure";
      };
    }
  | {
      readonly name: "commerce_allowance_exhausted";
      readonly schemaVersion: 1;
      readonly properties: {
      readonly "cost_driver": "recipe_import";
      };
    }
  | {
      readonly name: "commerce_grant_completed";
      readonly schemaVersion: 1;
      readonly properties: {
      readonly "environment": "sandbox" | "production";
      };
    }
  | {
      readonly name: "commerce_billable_action_committed";
      readonly schemaVersion: 1;
      readonly properties: {
      readonly "cost_driver": "recipe_import";
      readonly "funding": "free" | "purchased" | "mixed";
      };
    }
  | {
      readonly name: "prominent_cooking_alarm_preference_changed";
      readonly schemaVersion: 1;
      readonly properties: {
      readonly "enabled": boolean;
      readonly "authorization": "not_determined" | "denied" | "authorized" | "unsupported";
      };
    }
  | {
      readonly name: "app_review_experiment_event";
      readonly schemaVersion: 1;
      readonly properties: {
      readonly "experiment": "second_import_v1";
      readonly "variant": "prompt" | "holdout";
      readonly "phase": "enrolled" | "eligible" | "opportunity" | "request_attempted";
      };
    };

export type GeneratedProductEventName = GeneratedProductEventContract["name"];
export type GeneratedProductEventProperties<Name extends GeneratedProductEventName> =
  Extract<GeneratedProductEventContract, { name: Name }>["properties"];
